export default __webpack_public_path__ + "static/media/Intro-Card-1.fff13d8e.svg";